import { lazy } from "react";

export const LazyLogin = lazy(() => import("../pages/login"));
export const LazyAzureLoginSuccess = lazy(() =>
  import("../pages/azure-login-success")
);
export const LazyMainLayout = lazy(() => import("../pages/main-layout"));
export const LazyUserManagement = lazy(() => import("../pages/userManagement"));
export const LazyStudents = lazy(() =>
  import("../pages/userManagement/students")
);
export const LazyEstablishment = lazy(() => import("../pages/establishment"));
export const LazyPathology = lazy(() => import("../pages/pathology"));
export const LazyUserAdmins = lazy(() =>
  import("../pages/userManagement/admins")
);
export const LazyUserTeachers = lazy(() =>
  import("../pages/userManagement/teachers")
);
export const LazyMasterData = lazy(() => import("../pages/master-data"));
export const LazyForgotPassword = lazy(() =>
  import("../pages/forgot-password")
);
export const LazyEmailSent = lazy(() => import("../pages/email-sent"));
export const LazyVerify = lazy(() => import("../pages/verify"));
export const LazyCaseManagement = lazy(() =>
  import("../pages/case-management")
);
export const LazyCaseManagementDetails = lazy(() =>
  import("../pages/case-management/details")
);
export const LazyCaseManagementCreate = lazy(() =>
  import("../pages/case-management/create-case")
);
export const LazyCaseManagementSteps = lazy(() =>
  import("../pages/case-management/steps")
);
export const LazyMaterials = lazy(() => import("../pages/materials"));
export const LazyMaterialsList = lazy(() =>
  import("../pages/materials/materials")
);
export const LazyTrolleyConfiguration = lazy(() =>
  import("../pages/materials/trolley-configure")
);
export const LazyTreatment = lazy(() => import("../pages/treatment"));
export const LazyComplimentaryExaminations = lazy(() =>
  import("../pages/complimentary-examinations")
);
export const LazyStudentDashboard = lazy(() =>
  import("../pages/student-dashboard")
);
// export const LazyVirtualPatient = lazy(() =>
//   import("../pages/virtual-patient")
// );
export const LazyTargetGroups = lazy(() => import("../pages/target-groups"));
// export const LazyClinicalCaseManagement = lazy(() =>
//   import("../pages/clinical-case-management")
// );
export const LazyMonitoringLearnerPeformance = lazy(() =>
  import("../pages/monitoring-peformance")
);
export const LazyMonitoringPeformance = lazy(() =>
  import("../pages/monitoring-peformance/monitorLearnerPerformance")
);
export const MonitorPeformanceDebriefing = lazy(() =>
  import("../pages/monitoring-peformance/debriefing")
);
export const LazyMonitoringPeformanceStudentClinical = lazy(() =>
  import("../pages/monitoring-peformance")
);
export const LazyStudentClinicalCase = lazy(() =>
  import("../pages/student-clinical-case")
);
export const LazyStudentClinicalCaseDebriefing = lazy(() =>
  import("../pages/monitoring-peformance/debriefing")
);
export const LazyDashboard = lazy(() => import("../pages/dashboard"));

export const LazyStudentPerformanceTracking = lazy(() =>
  import("../pages/dashboard/student-performance-tracking")
);

export const LazyPerformanceBySpecialties = lazy(() =>
  import("../pages/dashboard/performance-by-specialties")
);

export const LazyPerformanceByClinicalActions = lazy(() =>
  import("../pages/dashboard/performance-by-clinical-actions")
);
export const LazyStudentSpeciality = lazy(() =>
  import("../pages/dashboard/students-speciality")
);

export const ExaminationRoom = lazy(() =>
  import("../pages/patient-simulation/examination-room")
);
export const LazyGeneralOverview = lazy(() =>
  import("../pages/dashboard/general-overview")
);
export const LazyPointSystem = lazy(() => import("../pages/point-system"));
export const LazySeedingPanelOutlet = lazy(() =>
  import("../pages/seeding-panel")
);
export const LazySeedingPanelData = lazy(() =>
  import("../pages/seeding-panel/superAdmin-seededData")
);
export const LazySeedingPanelAddThemes = lazy(() =>
  import("../pages/seeding-panel/add-themes")
);

export const LazyOrgansConfig = lazy(() =>
  import("../pages/seeding-panel/organ-config")
);
